import { NODON_ID_PREFIX } from '@shared/models/product.model';

export enum ConcretePropertyName {
  /**
   * Concrete type, cast in place or different prefab types like hollow core floors etc
   */
  Type = 'type',

  /**
   * Concrete quality, eg. C30/37
   */
  Quality = 'quality',

  /**
   * If concrete is climate improved or not.
   * Can be either true or false, or a specific climate improved level if type is cast in place.
   */
  ClimateImproved = 'climate_improved',

  /**
   * Amount of reinforcement steel in kg/m3
   */
  ReinforcementSteel = 'reinforcement_steel',

  /**
   * If the concrete should have stainless reinforcement or not
   */
  StainlessReinforcement = 'stainless_reinforcement',
}

export enum ConcreteType {
  // Horizontal

  /**
   * Platsgjuten (ej prefab)
   */
  CastInPlace = 'cast_in_place',

  /**
   * Balkonger och trappor
   */
  BalconyAndStairs = 'balcony_and_stairs',

  /**
   * Loftgångsplatta
   */
  BalconyAccessSlab = 'balcony_access_slab',

  /**
   * Balkar B, förspänd
   */
  BeamsPrestressed = 'beams_prestressed',

  /**
   * Balkar B, slakarmerad
   */
  BeamsSlackReinforced = 'beams_slack_reinforced',

  /**
   * Plattbärlag, PLE
   */
  FloorPlatesForFloorSystems = 'floor_plates_for_floor_systems',

  /**
   * Hålbjälklag
   */
  HollowCoreFloors = 'hollow_core_floors',

  /**
   * Massivplattor,  RD, RD/F
   */
  SolidFloorStructure = 'solid_floor_structure',
  /**
   * TT-plattor, TT,TT/F och STT/F
   */
  TTConcreteSlabs = 'TT concrete slabs',

  // Vertical

  /**
   * Pelare, RP, OP
   */
  Columns = 'columns',
  /**
   * Vägg/ytterskiva
   */
  ExternalWallPanels = 'external_wall_panels',

  /**
   * Halvsandwichväggar, VI, klimatförbättrad
   */
  HalfSandwichWallPanel = 'half_sandwich_wall_panel',

  /**
   * Sandwichväggar, W
   */
  SandwichWallPanels = 'sandwich_wall_panels',

  /**
   * Innervägg, V
   */
  SolidInteriorWallPanel = 'solid_interior_wall_panel',

  /**
   * Skalvägg VS
   */
  ThinShellPrecastPanels = 'thin_shell_precast_panels',

  /**
   * ??
   */
  Other = 'other',
}

export enum ConcreteQuality {
  C20_25 = 'C20/25',
  C25_30 = 'C25/30',
  C28_35 = 'C28/35',
  C30_37 = 'C30/37',
  C32_40 = 'C32/40',
  C35_45 = 'C35/45',
  C40_50 = 'C40/50',
  C45_55 = 'C45/55',
  C50_60 = 'C50/60',
  C55_67 = 'C55/67',
  C60_75 = 'C60/75',
}

export enum ClimateImprovedLevels {
  None = 'None',
  Level_1 = 'Level 1 (10%)',
  Level_2 = 'Level 2 (20%)',
  Level_3 = 'Level 3 (30%)',
  Level_4 = 'Level 4 (40%)',
}

export enum ConcreteProducts {
  C20_25 = 'boverket_sv-SE_6000000026',
  C20_25_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000026-10`,
  C20_25_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000026-20`,
  C20_25_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000026-30`,
  C20_25_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000026-40`,
  C25_30 = 'boverket_sv-SE_6000000029',
  C25_30_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000029-10`,
  C25_30_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000029-20`,
  C25_30_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000029-30`,
  C25_30_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000029-40`,
  C28_35 = 'boverket_sv-SE_6000000030',
  C28_35_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000030-10`,
  C28_35_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000030-20`,
  C28_35_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000030-30`,
  C28_35_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000030-40`,
  C30_37 = 'boverket_sv-SE_6000000032',
  C30_37_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000032-10`,
  C30_37_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000032-20`,
  C30_37_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000032-30`,
  C30_37_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000032-40`,
  C32_40 = 'boverket_sv-SE_6000000035',
  C32_40_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000035-10`,
  C32_40_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000035-20`,
  C32_40_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000035-30`,
  C32_40_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000035-40`,
  C35_45 = 'boverket_sv-SE_6000000036',
  C35_45_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000036-10`,
  C35_45_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000036-20`,
  C35_45_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000036-30`,
  C35_45_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000036-40`,
  C40_50 = 'boverket_sv-SE_6000000039',
  C40_50_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000039-10`,
  C40_50_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000039-20`,
  C40_50_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000039-30`,
  C40_50_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000039-40`,
  C45_55 = 'boverket_sv-SE_6000000042',
  C45_55_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000042-10`,
  C45_55_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000042-20`,
  C45_55_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000042-30`,
  C45_55_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000042-40`,
  C50_60 = 'boverket_sv-SE_6000000043',
  C50_60_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000043-10`,
  C50_60_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000043-20`,
  C50_60_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000043-30`,
  C50_60_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000043-40`,
  C55_67 = 'boverket_sv-SE_6000000046',
  C55_67_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000046-10`,
  C55_67_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000046-20`,
  C55_67_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000046-30`,
  C55_67_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000046-40`,
  C60_75 = 'boverket_sv-SE_6000000047',
  C60_75_climateImprovedLevel1 = `${NODON_ID_PREFIX}6000000047-10`,
  C60_75_climateImprovedLevel2 = `${NODON_ID_PREFIX}6000000047-20`,
  C60_75_climateImprovedLevel3 = `${NODON_ID_PREFIX}6000000047-30`,
  C60_75_climateImprovedLevel4 = `${NODON_ID_PREFIX}6000000047-40`,
  BalconyAndStairs = 'boverket_sv-SE_6000000074',
  BalconyAndStairsClimateImproved = 'boverket_sv-SE_6000000073',
  BalconyAccessSlab = 'boverket_sv-SE_6000000075',
  BalconyAccessSlabClimateImproved = 'boverket_sv-SE_6000000076',
  BeamsPrestressed = 'boverket_sv-SE_6000000071',
  BeamsPrestressedClimateImproved = 'boverket_sv-SE_6000000072',
  BeamsSlackReinforced = 'boverket_sv-SE_6000000069',
  BeamsSlackReinforcedClimateImproved = 'boverket_sv-SE_6000000070',
  FloorPlatesForFloorSystems = 'boverket_sv-SE_6000000063',
  FloorPlatesForFloorSystemsClimateImproved = 'boverket_sv-SE_6000000064',
  HollowCoreFloors = 'boverket_sv-SE_6000000059',
  HollowCoreFloorsClimateImproved = 'boverket_sv-SE_6000000060',
  SolidFloorStructure = 'boverket_sv-SE_6000000061',
  SolidFloorStructureClimateImproved = 'boverket_sv-SE_6000000062',
  TTConcreteSlabs = 'boverket_sv-SE_6000000049',
  TTConcreteSlabsClimateImproved = 'boverket_sv-SE_6000000050',
  Columns = 'boverket_sv-SE_6000000067',
  ColumnsClimateImproved = 'boverket_sv-SE_6000000068',
  ExternalWallPanels = 'boverket_sv-SE_6000000051',
  ExternalWallPanelsClimateImproved = 'boverket_sv-SE_6000000052',
  HalfSandwichWallPanel = 'boverket_sv-SE_6000000055',
  HalfSandwichWallPanelClimateImproved = 'boverket_sv-SE_6000000056',
  SandwichWallPanels = 'boverket_sv-SE_6000000058',
  SandwichWallPanelsClimateImproved = 'boverket_sv-SE_6000000057',
  SolidInteriorWallPanel = 'boverket_sv-SE_6000000054',
  SolidInteriorWallPanelClimateImproved = 'boverket_sv-SE_6000000053',
  ThinShellPrecastPanels = 'boverket_sv-SE_6000000065',
  ThinShellPrecastPanelsClimateImproved = 'boverket_sv-SE_6000000066',
  Other = 'boverket_sv-SE_6000000077',
  OtherClimateImproved = 'boverket_sv-SE_6000000078',
  ReinforcementSteel = 'boverket_sv-SE_6000000154',
  ReinforcementSteelStainless = 'boverket_sv-SE_6000000156',
}
